export class BrickLevel {
  id: number;
  name: string;
  isRootLevel: boolean;
  isLeafLevel: boolean;
  active: boolean;
  order: number;
}
